module.exports = __webpack_public_path__ + "img/hr-puberty-decal-07.29d395be.png";